// ============================================================
// src/api/reportApi.js
// ============================================================
import { apiFetch, getToken, API_BASE_URL } from './apiConfig';

export async function getWeeklySummary(weekEnding) {
  const q = weekEnding ? `?week_ending=${weekEnding}` : '';
  return apiFetch(`/reports/summary${q}`);
}



export async function getExportPreview(start, end, employeeId = '') {
  let url = `/reports/export?start=${start}&end=${end}`;
  if (employeeId) url += `&employee_id=${employeeId}`;
  return apiFetch(url);
}

export async function downloadExcel(start, end, employeeId = '') {
  // ← use format=excel, goes through same /export route on port 5000
  let url = `/reports/export?start=${start}&end=${end}&format=excel`;
  if (employeeId) url += `&employee_id=${employeeId}`;
  const blob = await apiFetch(url, { responseType: 'blob' });
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = `payroll_${start}_to_${end}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(objectUrl);
}

export async function downloadPDF(start, end, employeeId = '') {
  // ← use format=pdf, goes through same /export route on port 5000
  let url = `/reports/export?start=${start}&end=${end}&format=pdf`;
  if (employeeId) url += `&employee_id=${employeeId}`;
  const blob = await apiFetch(url, { responseType: 'blob' });
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = `payroll_${start}_to_${end}.pdf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(objectUrl);
}

export async function downloadCSV(start, end, employeeId = '') {
  // ← use format=csv, same pattern
  let url = `/reports/export?start=${start}&end=${end}&format=csv`;
  if (employeeId) url += `&employee_id=${employeeId}`;
  const blob = await apiFetch(url, { responseType: 'blob' });
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = `payroll_${start}_to_${end}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(objectUrl);
}